export default __webpack_public_path__ + "img/c08fd00cbd3a07ce9de455eb0f626a5c.svg";